import script from "./WorldSideMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./WorldSideMenu.vue?vue&type=script&setup=true&lang=js"

import "./WorldSideMenu.vue?vue&type=style&index=0&id=786031d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-786031d8"]])

export default __exports__